import { createSubsetSelector } from 'webui/utils/selectors';
import { getOpenThermStateName, OpenThermVariableName } from 'openTherm';
import { getLegacyBoilerName, getLegacyOpenThermObserveParams, } from '../../utils/open-therm';
import { ThermometerState } from 'webui/utils/thermometers';
import { boiler_adapter_ot_color } from 'z3k-settings/components/utils/ColorPicker4bit';
import { parseFloatWithComma, prettyFloat } from 'utils';
import { RfTypes } from 'z3k-parser/lib';
export const legacy_sensors_state = createSubsetSelector([
    'otzones_last',
    'last_boiler_state',
    'thermometers',
    'rf_status',
]);
export const legacy_sensors_config = createSubsetSelector([
    'id',
    'ot_zones_count',
    'thermostat_zones_settings',
    'thermometers',
    'rf_status',
    'ot_save_params',
    'ot_enabled',
    'ot_min_wp',
    'ot_max_ml',
]);
const legacy_open_therm_sensors = (ot_min_wp, ot_max_ml) => [
    {
        ot_name: OpenThermVariableName.rml,
        unit: '%',
        limits: { low: 0, high: ot_max_ml != null ? ot_max_ml : 100 },
    },
    {
        ot_name: OpenThermVariableName.wp,
        unit: 'бар',
        limits: {
            low: ot_min_wp != null ? parseFloatWithComma(prettyFloat(ot_min_wp, 1)) : 0,
            high: 3,
        },
    },
    {
        ot_name: OpenThermVariableName.fr,
        unit: 'л/мин',
        limits: { low: 0, high: 35 },
        show_limits: false,
    },
];
function getLegacyOpenThermSensor(props) {
    const { id: boiler_adapter_id, ot_index, ot_save_params, name = boiler_adapter_id === 1 ? `Котел` : `Котел ${boiler_adapter_id}`, ot_min_wp, ot_max_ml, } = props;
    const observed_open_therm_flags = getLegacyOpenThermObserveParams(legacy_open_therm_sensors(ot_min_wp, ot_max_ml), ot_save_params);
    return observed_open_therm_flags.map((sensor, index) => {
        const { ot_name, unit, limits, show_limits } = sensor;
        const open_therm_name = `${name} ${getOpenThermStateName(ot_name)}`;
        const id = (ot_index + index + boiler_adapter_id + 0.1);
        const open_therm = {
            boiler_adapter_id,
            ot_name,
        };
        return {
            id,
            name: open_therm_name,
            unit,
            boiler_adapter_id,
            color: boiler_adapter_ot_color[0],
            show_limits,
            open_therm,
            limits: {
                ...limits,
                high: limits.high,
            },
        };
    });
}
export function getLegacyOpenThermSensors(device) {
    const { ot_zones_count, ot_save_params, ot_enabled, thermostat_zones_settings, ot_max_ml, ot_min_wp, } = device;
    //1 АЦШ
    if (ot_enabled && ot_zones_count == 1) {
        const name = getLegacyBoilerName(thermostat_zones_settings, 1);
        const open_therm_sensors = getLegacyOpenThermSensor({
            id: 1,
            name,
            ot_save_params,
            ot_index: 0,
            ot_max_ml,
            ot_min_wp,
        });
        return open_therm_sensors;
    }
    // > 1 АЦШ
    if (ot_enabled) {
        const open_therm_sensors = Array(ot_zones_count)
            .fill(null)
            .flatMap((_zone, ot_index) => {
            const id = Number(ot_index + 1);
            const name = getLegacyBoilerName(thermostat_zones_settings, id);
            return getLegacyOpenThermSensor({
                id,
                ot_index,
                name,
                ot_save_params,
                ot_max_ml,
                ot_min_wp,
            });
        });
        return open_therm_sensors;
    }
    return [];
}
export function getLegacyRadioSensorsConfig(rf_status, thermometers) {
    const radio_sensors = Object.entries(rf_status).map(([serial, sensor]) => {
        const { last_state, limits, color } = thermometers.find((thermometer) => thermometer.serial === serial) || {};
        const { slot, name: initial_name, uninitialized = true, type } = sensor;
        if (uninitialized) {
            return null;
        }
        const id = (slot + 0.2);
        const name = initial_name ? initial_name.toString() : '';
        const no_connection = last_state === ThermometerState.not_connected;
        const sensor_values = {
            id,
            name,
            color,
            serial,
            limits: limits && type !== RfTypes.MLH ? limits : { high: null, low: null },
            no_connection,
        };
        if (type === RfTypes.MLW) {
            return {
                ...sensor_values,
                icon: 'leak',
            };
        }
        if (type === RfTypes.MLH) {
            return {
                ...sensor_values,
                unit: '%',
                icon: 'humidity',
            };
        }
        if (type === RfTypes.MLM) {
            return {
                ...sensor_values,
                icon: 'motion',
            };
        }
        if (type === RfTypes.MLK) {
            return {
                ...sensor_values,
                value: null,
                alarm: false,
            };
        }
        return null;
    });
    return radio_sensors;
}
